// eslint-disable-next-line max-classes-per-file
import {
  RecurringTimeSpan,
  RecurringTimeSpansMixin,
  Store,
  TimeSpan,
} from '@bryntum/gantt/gantt.module';

// Define a new Model extending TimeSpan class
// with RecurringTimeSpan mixin which adds recurrence support
class CustomTimeSpanModel extends RecurringTimeSpan(TimeSpan) {
  constructor(config) {
    super(config, true);
  }
}

// Define a new store extending the Store class
// with RecurringTimeSpansMixin mixin to add recurrence support to the store.
// This store will contain time ranges.
class CustomTimeRangeStore extends RecurringTimeSpansMixin(Store) {
  constructor(config) {
    super(config, true);
  }

  static get defaultConfig() {
    return {
      modelClass: CustomTimeSpanModel,
      storeId: 'timeRanges',
    };
  }
}

export const weekendConfig = new CustomTimeRangeStore({
  data: [
    {
      id: 1,
      recurrenceRule: 'FREQ=WEEKLY;BYDAY=SA',
      startDate: '1970-01-01',
      duration: 1,
    },
    {
      id: 2,
      recurrenceRule: 'FREQ=WEEKLY;BYDAY=SU',
      startDate: '1970-01-01',
      duration: 1,
    },
  ],
});
